module.exports = __webpack_public_path__ + "static/media/3.782eaf7f.svg";